import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ValuesPage from "@/pages/ValuesPage";
import TrainingPage from "@/pages/TrainingPage";
import HealthSafetyPage from "@/pages/HealthSafetyPage";
import RecruitmentPage from "@/pages/RecruitmentPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyDetailPage from "@/pages/CaseStudyDetailPage";
import ContactPage from "@/pages/ContactPage";
import WhyUsPage from "@/pages/WhyUsPage";
import YourCommsPage from "@/pages/YourCommsPage";
import FundingPage from "@/pages/FundingPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
    <div className="min-h-screen bg-[#050505]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/staff-engagement" element={<ValuesPage />} />
          <Route path="/training" element={<TrainingPage />} />
          <Route path="/health-safety" element={<HealthSafetyPage />} />
          <Route path="/recruitment" element={<RecruitmentPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact/:defaultView" element={<ContactPage />} />
          <Route path="/why-us" element={<WhyUsPage />} />
          <Route path="/your-comms" element={<YourCommsPage />} />
          <Route path="/funding" element={<FundingPage />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
